import { createSlice } from '@reduxjs/toolkit';
import { fetchSickLeaveStatistics } from '../thunks/sickLeaveStatsThunks.js';

const initialState = {
    loading: false,
    maxPageNumber: 0,
    statistics: [],
    error: null,
    summaryDays: 0,
};

const sickLeaveStatsSlice = createSlice({
    name: 'sickLeaveStats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSickLeaveStatistics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSickLeaveStatistics.fulfilled, (state, action) => {
                state.loading = false;
                state.statistics = action.payload.statistics;
                state.summaryDays = action.payload.summaryDays;
                state.maxPageNumber = action.payload.maxPageNumber;
            })
            .addCase(fetchSickLeaveStatistics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch sick leave statistics';
            })
            .addDefaultCase((state) => state);
    },
});

export default sickLeaveStatsSlice.reducer;
